// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"188":"6cc22917","856":"543e7d7f"}[chunkId] + ".js";
};